export var IdAssetBundleLibrary;
(function (IdAssetBundleLibrary) {
    IdAssetBundleLibrary["Library_0"] = "Library_0";
    IdAssetBundleLibrary["Library_1"] = "Library_1";
    IdAssetBundleLibrary["Library_2"] = "Library_2";
    IdAssetBundleLibrary["Library_3"] = "Library_3";
    IdAssetBundleLibrary["Library_4"] = "Library_4";
    IdAssetBundleLibrary["Library_5"] = "Library_5";
    IdAssetBundleLibrary["Library_6"] = "Library_6";
    IdAssetBundleLibrary["Library_7"] = "Library_7";
})(IdAssetBundleLibrary || (IdAssetBundleLibrary = {}));



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/outskirts/IdAssetBundleLibrary.ts
// module id = 2139
// module chunks = 3